import { brandingActions } from '../../redux/actions/branding.action';
import { colorActions } from '../../redux/actions/color.actions';
import { clientUserIdActions } from '../../redux/actions/clientUserId.action';
import { get } from '../../Utilities/Remote';
import { history } from '../../Routing';
import { userProfileActions } from '../../redux/actions/userProfile.action';
import { dashboardActions } from '../../redux/actions/dashboard.action';
import { iosCaller, isIosApp, isWebView } from '../../Utilities';
import { ensureClientTags } from '../../Utilities/analytics';

export function getBranding(param) {
  return (dispatch) => {
    dispatch(brandingActions.clear());

    get(param, '/getClientbyDomain')
      .then((res) => {
        if (res && res.success) {
          if (res.result === 'invaid_domain') {
            history.push('/invalidurl');
            return;
          }
          const clientid = res.result[0].client_id;
          dispatch(dashboardActions.setCreditsAvailableToStore(res.result[0].credits_available));
          dispatch(clientUserIdActions.setClientIdToStore(clientid));
          // fire-and-forget: must not block branding; loads the client's analytics tags (GTM/pixel)
          ensureClientTags(clientid);
          if (isWebView && typeof window.Android.saveClientId !== 'undefined') {
            window.Android.saveClientId(String(clientid));
          } else if (isIosApp) {
            iosCaller('saveClientId', String(clientid));
          }
          dispatch(brandingActions.success(res.result[0]));
        }
      })
      .catch((e) => dispatch(brandingActions.error(e)));
  };
}

export function getColor(param) {
  return (dispatch) => {
    dispatch(colorActions.clear());
    dispatch(colorActions.success(param));
  };
}

export function getContact(param, countryCode) {
  return (dispatch) => {
    dispatch(userProfileActions.setContactToStore(param));
    dispatch(userProfileActions.setCountryCodeToStore(countryCode));
  };
}

export function setComponent(param, countryCode) {
  return (dispatch) => {
    dispatch(brandingActions.setCurrentComponentToStore(param));
  };
}
